export default __webpack_public_path__ + "a93e5a37df53592893940710ca33e330.svg";